<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div>
  <h1 mat-dialog-title>Add New Subregion</h1>
  <mat-dialog-content>
    <div class="d-flex flex-column gap-8">
      <mat-form-field>
        <mat-label>Subregion:</mat-label>
        <input matInput [(ngModel)]="subregionName">
      </mat-form-field>
    </div>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Select Region</mat-label>
      <mat-select [(ngModel)]="selectedRegion">
        <mat-option *ngFor="let region of regions"
                    [value]="region.region">{{ region.region }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="pt-3 d-flex gap-8">
      <button mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-raised-button color="primary"
              [disabled]="!selectedRegion || !subregionName"
              (click)="addSubregion()">
        Create
      </button>
    </div>
  </mat-dialog-content>
</div>
